module.exports = __webpack_public_path__ + "static/media/facebook-logo.95c4c698.png";